import axiosInstance from './axiosInstance'

export const getPayoutHistories = () => {
  return axiosInstance.get('/payout-histories')
}

export const createPayoutHistory = (data) => {
  return axiosInstance.post('/payout-histories', data)
}

export const updatePayoutHistory = (payoutId, data) => {
  return axiosInstance.put(`/payout-histories/${payoutId}`, data)
}

export const deletePayoutHistory = (payoutId) => {
  return axiosInstance.delete(`/payout-histories/${payoutId}`)
}
